/**
 * 深度洞察-数据采集&解析 / 报告生成 权益点计费规则（产品侧已确认，2026.07.07）：
 * - 数据采集&解析：问题条数 × 1 × 洞察模型数（即每题每模型 1 点）
 * - 品牌洞察报告：固定 100 点/份（固定权益点）
 * - 合计公式：问题数 × 1 × 模型数 + 固定权益点
 * 品牌画像收集、测评问题生成、问题打标现阶段限时免费（0 点）。
 */
export const RATE_PER_QUESTION_PER_PLATFORM = 1
export const REPORT_COST = 100

export function formatPoints(n: number): string {
  const rounded = Math.round(n * 10) / 10
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1)
}

export function computeCollectionCost(questionCount: number, platformCount: number): number {
  return questionCount * platformCount * RATE_PER_QUESTION_PER_PLATFORM
}

export function computeTotalCost(questionCount: number, platformCount: number): number {
  return computeCollectionCost(questionCount, platformCount) + REPORT_COST
}
